module.exports = __webpack_public_path__ + "media/theme/logo_admin-99ee6058.png";